const PROTECTING_STATUS = {
  loading: "loading",
  protected: "protected",
  unprotected: "unprotected",
};

export { PROTECTING_STATUS };
